export const {
  REACT_APP_ENV = 'development',
  ESLINT_NO_DEV_ERRORS = true,
  REACT_APP_REVENUECAT_BILLING_SANDBOX_API_KEY = 'default_sandbox_key',
  REACT_APP_REVENUECAT_BILLING_PUBLIC_API_KEY = 'default_key',
  REACT_APP_REVENUECAT_APP_USER_ID = 'app_user_id',
  REACT_APP_AMPLITUDE_API_KEY = 'default_key',
  REACT_APP_IPINFO_API_KEY = 'default_key',
} = process.env;
